import {
  GLOBAL_MODAL_OPEN,
  GLOBAL_MODAL_CLOSE,
  GLOBAL_MODAL_VISIBILITY,
  GLOBAL_MODAL_DATA,
  GLOBAL_MODAL_OPTIONS,
} from './storeTypes';

export default {
  state() {
    return {
      modals: [],
      lastOpenModal: null,
    };
  },

  getters: {
    [GLOBAL_MODAL_VISIBILITY]({ modals }) {
      return modals.length > 0;
    },

    [GLOBAL_MODAL_DATA]({ modals, lastOpenModal }) {
      const currentModal = modals[modals.length - 1] || lastOpenModal || {};

      return {
        title: currentModal.title || null,
        component: currentModal.component || (() => null),
        props: currentModal.props || {},
      };
    },

    [GLOBAL_MODAL_OPTIONS]({ modals, lastOpenModal }) {
      const currentModal = modals[modals.length - 1] || lastOpenModal || {};

      return currentModal.options || {};
    },
  },

  mutations: {
    [GLOBAL_MODAL_OPEN](
      { modals },
      { title, component, props, resolve, options },
    ) {
      modals.push({
        title: title,
        component: () => component,
        props: props,
        resolve: resolve,
        options: options,
      });
    },

    [GLOBAL_MODAL_CLOSE](stateObj, result) {
      const closedModal = stateObj.modals.pop();
      if (!closedModal) return;

      stateObj.lastOpenModal = closedModal;

      if (typeof closedModal?.resolve === 'function') {
        closedModal.resolve(result);
      }
    },
  },

  actions: {
    [GLOBAL_MODAL_OPEN]({ commit }, modalData) {
      commit(GLOBAL_MODAL_OPEN, modalData);
    },

    [GLOBAL_MODAL_CLOSE]({ commit }, result) {
      commit(GLOBAL_MODAL_CLOSE, result);
    },
  },
};
